<template>
    <section>
      <dialog-component v-if="dialog.isShow" @dialogClose="d => (closeDialogComponent(), d())" :dialog="dialog">
          <template v-if="currentType === 'move$'">
              <div slot="content" :class="shit$(`h:276px;`)">
                  <div :class="shit$(`h:88px; pt:14px; pb:19px; px:20px;`)">
                      <p :class="shit$(`font:14px; letter-s:0.5px;`)">{{ move$.label }}</p>
                      <section :class="shit$(`mt:14px; dis:f;`)">
                          <span @mousedown="e => backPreveClick = true" @mouseup="e => backPreveClick = false" @click="backPrelevelCb" :class="shit$('cursor:p; lh:1.4;')">
                              <svg-icon height="15" width="15" :href="backPreveClick ? '#code-lab-back-preve-press-icon' :'#t-cod-dialog-back-icon'"></svg-icon>
                          </span>
                          <T-header :mode="1" ref="headerRef" @getClickMsg="msg =>(
                              getArrayLastItem(headerData).index === msg.index || handleHeaderData(msg), checkIsAllowMove(msg))"
                            :info="headerData" :class="[shit$(`font:14px; letter-s:1.29px; ml:3px; width:100%;`)]"/>
                      </section>
                  </div>
                  <div :class="shit$(`h:188px; overflow:a;`)">
                      <template v-for="item in folderList">
                          <section @click.stop="isOpen(item) || clickItemCb(item)" :key="item[item.type$]"
                              :class="[isOpen(item) && shit$(`bgc:rgba(0,0,0,0.4)!;`),
                                 shit$(`px:20px; dis:f; align-i:c; justify-c:sb; py:10px; hover:bgc:rgba(255, 255, 255, 0.2);`)]">
                              <span :class="shit$(`dis:i-b; cursor:p;`)">
                                  <svg-icon height="50" width="50" :href="folderIsFn(item) ? '#t-code-file-management-folder' : '#t-code-file-management-project'"></svg-icon>
                              </span>
                              <p :class="shit$(`letter-s:0.86px; dis:f; flex-d:c;`)">
                                <span>{{ strSliceStarAndEndT(item.name$, 18, 13, '..') }}</span>
                                <span v-if="isOpen(item)" :class="shit$(`c:#696969; font:12px; letter-s:0.86px; mt:5px;`)">{{ item.openUserName }} {{this.$t( "code-lab/component/file-management/dialog.vue_0" ) }}...</span>
                              </p>
                              <span :class="shit$(`h:20px; w:20px;`)"><svg-icon v-if="folderIsFn(item)" height="20" width="20" href="#t-cod-dialog-next-icon"></svg-icon></span>
                          </section>
                      </template>
                  </div>
              </div>
          </template>
          <template v-if="currentType === 'rename$' || currentType === 'delete$' || currentType === 'add$'">
              <div v-if="this[currentType]" slot="content" :class="shit$(`px:30px;`)">
                  <p v-if="this[currentType].popLabel" :class="shit$(`font:14px; font-w:500; letter-s:1px; c:#ffffff; text-a:c; pt:25px; mb:8px;`)">{{ this[currentType].popLabel }}</p>
                  <p v-if="this[currentType].describe" :class="[shit$(`font:14px; font-w:500; letter-s:1px; c:#ffffff; text-a:c; pb:25px;`), !this[currentType].popLabel && shit$(`pt:25px; lh:1.4;`)]">{{ this[currentType].describe }}</p>
                  <p v-if="this[currentType].label" :class="shit$(`font:14px; letter-s:0.5px; pt:10px;`)">{{ this[currentType].label }}</p>
                  <div :class="shit$(`mb:23px;`)" v-if="this[currentType].placeholder">
                    <input v-focus v-model.trim="input" :placeholder="this[currentType].placeholder" type="text" :class="[shit$(`text-a:c;`), input ? !inputValidated ? shit$(`c:#0ed3ff!;`) : shit$(`bc:#FF8281!; c:#FF8281!;`) : shit$(`bc:#272727;`), shit$(`w:100%; px:21px; py:15px; h:50px; radius:8px; b:1px; mt:8px; bgc:transparent; font:14px; font-w:500; bc:#a8a8ac; color:#a8a8ac; letter-s:0.5px;`)]"/>
                    <span :class="shit$(`mt:5px; dis:b; font:12px; c:${ inputValidated && '#FF8281' }; visibility:${ inputValidated && input ? 'visible' : 'hidden'};`)">{{ overMaxInputLen ? this[currentType].type + this.$t("code-lab/component/file-management/dialog.vue_1") : $t(`message.error_project_name`) }}</span>
                  </div>
                  <p v-if="this[currentType].name$" :class="shit$(`letter-s:1px; font:14px; c:#fff; font-w:500; py:25px; text-a:c;`)">{{this.$t( "code-lab/component/file-management/dialog.vue_2" ) }}「{{ strSliceStarAndEndT(this[currentType].name$, 11, 6, '..')  }}」{{this.$t( "code-lab/component/file-management/dialog.vue_3" ) }}？</p>
              </div>
          </template>
          <template v-if="currentType === 'shared$'">
            <section v-if="this[currentType]" slot="content" :class="shit$(`font:14px; px:30px; pt:25px; pb:46px; c:#fff;`)">
              <div :class="shit$(`justify-c:sb; dis:f; align-i:c;`)">
                <span>{{this.$t( "code-lab/component/file-management/dialog.vue_4" ) }}</span> 
                <p :class="shit$(`dis:f; align-i:c;`)">
                    <span :class="[shit$(`mr:5px;`), switchState && shit$('c:#00b5e2;')]">{{this.$t( "code-lab/component/file-management/dialog.vue_5" ) }}</span>
                    <el-switch
                    v-model="switchState"
                    active-color="#00b5e2"
                    inactive-color="#333333">
                  </el-switch>
                </p>
              </div>
              <div :class="shit$(`mt:25px;`)">
                <section v-if="switchState">
                  <p >{{this.$t( "code-lab/component/file-management/dialog.vue_6" ) }}</p>
                  <el-select :class="shit$(`mt:10px;`)" v-model="switchDataValue" multiple :placeholder="attrStrDialog">
                    <el-option
                      :class="shit$(`hover:bgc:#444444;`)"
                      v-for="item in switchData"
                      :key="item.groupId"
                      :label="item.groupName"
                      :disabled="item.disabled"
                      :value="item.groupId" />
                  </el-select>
                </section>
                <p v-else :class="shit$(`letter-s:0.5px; lh:1.4;`)">{{ this[currentType].describe }}</p>
              </div>
            </section>
          </template>
          <template v-if="currentType === 'export$'">
              <div v-if="this[currentType]" slot="content" :class="shit$(`px:30px; py:25px; text-a:c;`)">
                  <p :class="shit$(`font:14px; font-w:500; letter-s:1px; c:#ffffff;`)">{{this.$t( "code-lab/component/file-management/dialog.vue_7" ) }}「{{ strSliceStarAndEndT(this[currentType].name$, 13, 8, '..') }}」{{this.$t( "code-lab/component/file-management/dialog.vue_8" ) }}</p>
                  <p v-if="!connectGolbalState" :class="shit$(`font:12px; font-w:500; letter-s:0.43px; mt:12px;`)">{{this.$t( "code-lab/component/file-management/dialog.vue_9" ) }}“{{this.$t( "code-lab/component/file-management/dialog.vue_10" ) }}”{{this.$t( "code-lab/component/file-management/dialog.vue_11" ) }}～</p>
              </div>
              <div slot="footer" :class="[shit$(`font:16px; letter-s:0.48px;`), shit$(`dis:f; align-i:c; justify-c:sb; px:30px;`), mappingDialogFooterShit(currentType)]">
                  <section @click="() => this[this[currentType].handler]({ key: this[currentType].footer.left.key, projectId: this[currentType].id })"
                    :class="[shit$(`bgc:rgba(14, 211, 255, 0.6); cursor:p; c:#fff; font-w:500;`), this.assembleCommonBtnShit()]">{{ this[currentType].footer.left.label }}</section>
                  <section @click="() => this[this[currentType].handler]({ key: this[currentType].footer.right.key, projectId: this[currentType].id })"
                    :class="[shit$(`bgc:rgba(31, 31, 31, 0.5); cursor:n; c:#696969;`), connectGolbalState && shit$(`bgc:rgba(14, 211, 255, 0.6)!; cursor:p!; c:#fff!; font-w:500;`), !connectGolbalState && this.assembleCommonNormalShit(), this.assembleCommonBtnShit(),]">{{ this[currentType].footer.right.label }}</section>
              </div>
          </template>
          <template v-if="currentType !== 'export$'">
              <div slot="footer" :class="[shit$(`font:16px; letter-s:0.48px;`), shit$(`dis:f; align-i:c; justify-c:sb; px:30px;`), mappingDialogFooterShit(currentType)]">
                  <section @click="() => closeDialogComponent()" :class="[shit$(`bgc:#727272; cursor:p;`), this.assembleCommonBtnShit()]">{{ this[currentType].footer.left }}</section>
                  <template v-if="currentType === 'add$' && this[currentType].target.type$ === 'projectId'">
                      <section @click="() => this[this[currentType].handler]()" :class="[shit$(`bgc:rgba(31, 31, 31, 0.5); cursor:n;`), this.assembleCommonBtnShit(), (currentType === 'add$') ? this.btnSelectedShit() : this.assembleCommonNormalShit()]">{{ this[currentType].footer.right }}</section>
                  </template>
                  <template v-else>
                      <section @click="() =>
                        isAllowedOpenSharedPop() ? openSharedPop() : this[this[currentType].handler]()"
                        :class="[shit$(`bgc:rgba(31, 31, 31, 0.5); cursor:n; c:#696969;`), this.assembleCommonBtnShit(), (((this.isNotStr(this.currentSelectedFolderId) && !this.currentSelectedFolderId) || this.currentSelectedFolderId) || (input && !inputValidated) || currentType === 'delete$' || currentType === 'shared$') ? this.btnSelectedShit() : this.assembleCommonNormalShit()]">{{ this[currentType].footer.right }}</section>
                  </template>
              </div>
          </template>
      </dialog-component>
      <pop-dialog @confirm-back="() => this[this[currentType].handler]()" :data="popDialog" @back-switch="data => popDialog.switch = data" v-if="popDialog.switch" />
    </section>
</template>

<script>
import THeader from "@/code-lab/component/file-management/header.vue";
import DialogComponent from "@/code-lab/view/organization/s-dialog.vue";
import mixFileManagement from "@/code-lab/component/file-management/mixins/mix-file-request-manage.js"; 
import projectFolderCrud from "@/code-lab/component/file-management/mixins/project-folder-crud.js";
import mixTableDataCrud from "@/code-lab/component/file-management/mixins/mix-table-data-crud.js";
import mixTool from '@/code-lab/component/file-management/mixins/tool-mix.js'
import PopDialog from '@/code-lab/component/file-management/popDialog.vue'
import { store as dialogNotifyStore, mutations as dialogNotifyMutations } from '@/code-lab/component/file-management/dialog-notify/observable.js'
import { mapState, mapActions } from 'vuex'
export default {
  mixins: [ mixFileManagement, projectFolderCrud, mixTableDataCrud, mixTool ],
  props: {
    data: Object,
    options: Object,
    headerDataD: Array,
    folderListD: Array,
    currentWhereFolderOfTable: Object
  },
  components: {
    DialogComponent,
    "T-header": THeader,
    PopDialog
  },
  computed: {
    ...mapState('user', [
        'teamId',
        'token'
    ]),
    ...mapState(['groupTeamArr', 'currentVersion', 'connectGolbalState', 'regularVer']),
    ...mapState('notifySystem', { notifyInstance: 'notifyInstance' }),
    switchData () {
      const data = this.groupTeamArr
      return [
        {
          groupId: '',
          groupName: this.$t("code-lab/component/file-management/dialog.vue_12"),
        }, ...data]
    }
  },
  data () {
    return {
      attrStrDialog: this.$t("code-lab/component/file-management/dialog.vue_13"),
      popDialog: {
        switch: false,
        data: {},
        dialog: {},
        clickTarget: {}
      },
      dialog: {
        showClose: false,
        width: "400px",
        isShow: false,
        isFooter: true,
        title: "",
        class: "dialogOfManagecustomClass",
        closeOnEscape: false,
        closeOnModal: false
      },
      add$: {},
      move$: {},
      rename$: {},
      delete$: {},
      export$: {},
      shared$: {},
      input: "",
      inputValidated: false,
      overMaxInputLen: false,
      switchState: false,
      switchDataValue: [''],
      currentType: "",
      judgeTimer: null,
      currentSelectedFolderId: '',
      backPreveClick: false,
      // notAllowedExportProjectToRobot: true
    }
  },
  methods: {
    ...mapActions("notifySystem", { newAct$: 'new' }),
    initOpenStatusConfig(){

    },
    openSharedPop () {
      const obj = Object.assign(this.popDialog, { data: { target: this[this.currentType].target } })
      const { clickTarget, data } = obj
      const isPrivate = data.target.every(item => this.isTypeOfFileT(item, "private"))
      const isTargetFolderPrivate = this.isTypeOfFileT(clickTarget, 'private');
      if (isPrivate && isTargetFolderPrivate) {
        this[this[this.currentType].handler]()
      } else {
        Object.assign(this.popDialog, { switch: true, })
      }
    },
    isAllowedOpenSharedPop () {
      if(this.currentVersion !== 'teacher'){
        return false;
      }
      const folderId = this.currentSelectedFolderId || this.isNotStr(this.currentSelectedFolderId)
      return !!folderId  && this.currentType === 'move$'
    },
    isOpen (data) {
      return data.isOpen === true && this.currentVersion !== 'family'
    },
    getItemId(item) {
        return item[item.type$]
    },
    isNotStr (data) {
      return typeof data !== 'string'
    },
    
    btnSelectedShit() {
      return this.shit$(`bgc:rgba(14, 211, 255, 0.6)!; font-w:500; cursor:p!; c:#fff!;`);
    },
    assembleCommonBtnShit() {
      return this.shit$(`w:160px; h:48px; radius:32.5px; text-a:c; lh:48px; c:#fff;`) + this.assembleCommonActiveShit()
    },
    assembleCommonActiveShit() {
      return this.shit$(`active:opacity:.6;`);
    },
    assembleCommonNormalShit() {
      return this.shit$(`active:opacity:1!;`);
    },
    
    mappingDialogFooterShit(key) {
      const mp = { move$: `absolute; left:0px; bottom:0px; h:100px; w:100%; bblr:25px; bbrr:25px; box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.5);` }
      return this.shit$(mp[key])
    },
    checkIsAllowMove () {
      const allPathIds = this.headerData.map(mp => mp.query.folderId)
      const toPath = this.headerData.slice(-1)[0]
      const { path: toPathName, folderId: toPathId } = toPath.query
      const originFolder = this.handleMoveData(this.move$.target[0]);
      const { targetFolderId, targetFolderName, targetFolderPath } = originFolder;
      let movedPath = toPathName === '/' ? toPathName + targetFolderName : toPathName + (targetFolderName ? '/' + targetFolderName : targetFolderName)
      let hasTargetIdIs = allPathIds.some(sm => sm === targetFolderId)
      const isFolder = this.folderIsFn(this.move$.target[0]);
      if (isFolder) { 
        let pathIsSame = this.equalIs(movedPath, targetFolderPath)
        !hasTargetIdIs && !pathIsSame ? Object.assign(this, { currentSelectedFolderId: toPathId }) : Object.assign(this, { currentSelectedFolderId: '' })
      } else { 
        let pathIsSame = this.equalIs(toPathName, targetFolderPath)
        !pathIsSame ? Object.assign(this, { currentSelectedFolderId: toPathId }) : Object.assign(this, { currentSelectedFolderId: '' })
      }
    },
    handleMoveData (row) {
      const { folderId, path } = this.getArrayLastItem(this.headerDataD).query
      const pathName = this.getArrayLastItem(path.split('/'))
      if (this.folderIsFn(row)) {
        return  Object.assign({}, { targetFolderId: row._id, targetFolderPath: row.path, targetFolderName: row.name$ })
      }
      return Object.assign({}, { targetFolderId: folderId, targetFolderPath: path, targetFolderName: pathName })
    },
    
    clickItemCb(item) {
      window.clearTimeout(this.judgeTimer)
      this.judgeTimer = window.setTimeout(() => {
        if (!this.folderIsFn(item)) return
        this.folderIsFn(item) ? this.handlePreviewData(item) : () => {}
        this.checkIsAllowMove(this.getItemId(item))
      }, 200)
    },
    backPrelevelCb() {
      if (this.getItemOfArray(this.headerData, -1).rootIs) return // l$("root folder!")
      const data = this.headerData.slice(-2)[0]
      this.handleHeaderData(data) 
      this.checkIsAllowMove(data)
    },
    exportProjectToComputer$ (url) {
      this.downloadToComputerT(url)
    },
    
    exportProjectRequest$ ({ projectId }, cb, robot) {
      let requestId
      if (robot) {
        requestId = this.util$.getRandomId$('export_execute_file')
        this.newAct$({ hide: false, hidePercent: true, id: requestId, progress: 0, content: this.$t("code-lab/component/file-management/dialog.vue_14"), title: this.$t("code-lab/component/file-management/dialog.vue_15"), href: "static/svg/pop/loading.svg", svg: '#t-code-notify-manage-loading', duration: 0 })
        
      }
      this.export_execute_file$(res => {
        // l$(res, 'export_execute_file')
        const arr = ["done", "task_creating", "task_created", "task_finished", 'todo']
        if (!arr.includes(res.data.state)) return robot && this.importFailed(requestId)
        if (res.data.state === "task_finished") {
          let url = res.data.url +  `?customerId=${this.teamId}&token=${this.token}`
          robot ? cb(url, requestId) : cb(url)
        }
      }, { projectId })
    },
    exportProjectToRms$ (url, notifyId) {
      const index = this.notifyInstance.findIndex(f => f.id === notifyId)
      this.b$.send(
        "rms",
        { cmd: "set_code_install", data: { url } },
        res => {
          if (res.status && Number(res.status.code) === 0) {
            this.importSuccess(notifyId, index)
          }
          console.log(res, "set_code_install rms")
        }
      )
    },
    exportProjectToQuick$ (url, notifyId) {
      const index = this.notifyInstance.findIndex(f => f.id === notifyId)
      const { serialNumber, to } = this.b$.quick.store
      this.b$.send(
        "quick",
        {
          cmd: "set_code_install",
          data: {
            destinationName: this[this.currentType].name$ || this.$t( "code-lab/component/file-management/dialog.vue_16" ),
            from: serialNumber,
            size: 0,
            url,
            to
          }
        },
        res => {
          if (res.cmd === "code_install_response" && res.data) {
            if (typeof res.data.result !== 'boolean') return console.log("must a boolean")
            if (res.data.result) {
              this.importSuccess(notifyId, index)
            } else if (!res.data.result) {
              this.importFailed(notifyId)
            }
          }
          console.log(res, "set_code_install quick")
        }
      )
    },
    exportProjectCb ({ key, projectId }) {
      // this.l$({ key, projectId })
      const mp = { 0: "exportProjectToComputer$", 1: { 1: 'exportProjectToRms$', 2: 'exportProjectToQuick$' }}
      // if (this.connectGolbalState === 2 && key !== 0) return console.log(this.$t("code-lab/component/file-management/dialog.vue_17"))
      const fn = mp[key]
      fn && typeof fn === 'string'
      ? this.exportProjectRequest$({ key, projectId }, this[fn])
      : this.connectGolbalState ? this.exportProjectRequest$({ key, projectId }, this[fn[this.connectGolbalState]], true): console.error(this.$t("code-lab/component/file-management/dialog.vue_18"))
      this.closeDialogComponent()
    },
    importFailed (requestId) {
        const index = this.notifyInstance.findIndex(f => f.id === requestId)
        this.$store.commit("notifySystem/update",
            { id: requestId, notify: { svg: '#code-lab-import-failed-icon', href: "static/svg/pop/filed.svg", progress: 100, title: this.$t("code-lab/component/file-management/dialog.vue_19"), content: `${ this.$t("code-lab/component/file-management/dialog.vue_20") }... ${ this.$t("code-lab/component/file-management/dialog.vue_21") }，${ this.$t("code-lab/component/file-management/dialog.vue_22") }！` }
        }),
        window.clearInterval(this.notifyInstance[index].timer)
    },
    importSuccess (notifyId, index) {
        this.$store.commit("notifySystem/update", { id: notifyId, notify: { href: "static/svg/pop/successful.svg", svg: '#code-lab-import-successful-icon', progress: 100, title: this.$t("code-lab/component/file-management/dialog.vue_23"), content: `${ this.$t("code-lab/component/file-management/dialog.vue_24") }，` }})
        window.clearInterval(this.notifyInstance[index].timer)
        dialogNotifyMutations.data({ ...dialogNotifyStore.map[this.connectGolbalState], title: this.$t("code-lab/component/file-management/dialog.vue_25"),  isShow: true, class: "dialogOfManagecustomClass dialogOfManagecustomClassCrud", })
    },
    
    sharedProjectFolderCb (res) {
      const isFolder = this.folderIsFn(this.shared$.target[0])
      if (res) {
        this.operatioSuccessfulFn();
      } else {
        const funcName = isFolder ? "edit_folder$" : "edit_project$";
        const isPrivate = !this.switchState;
        const isPublic = !isPrivate && (this.switchDataValue.includes('') || this.switchDataValue.length === 0);
        const groupIds = (isPrivate || isPublic) ? [] : this.switchDataValue;
        const openStatus = isPrivate ? 'private': (isPublic ? 'public' : 'group');
        const opts = { openStatus, groupIds }
        const ids = this.shared$.target.map(item => this.getItemId(item))
        if(isFolder){
          opts.folderIds = ids;
          opts.folderId = ids[0];
        } else {
          opts.projectIds = ids;
          opts.projectId = ids[0];
        }
        this[funcName](this.sharedProjectFolderCb, opts); 
      }
    },
    
    moveProjectFolderCb(res) {
      const isFolder = this.folderIsFn(this.move$.target[0]);
      if (res) {
        this.operatioSuccessfulFn();
      } else {
        
        if (!this.currentSelectedFolderId && !this.isNotStr(this.currentSelectedFolderId)) return
        const folderId = this.currentWhereFolder._id
        const funcName = isFolder ? "edit_folder$" : "move_project$";
        const ids = this.move$.target.map(item => this.getItemId(item))
        let params = {};
        if(isFolder){
          params = { moveFolderId: folderId, folderId: ids[0], folderIds: ids, ...this.getRequestQuery(this.currentWhereFolder) }
        } else {
          params = { projectIds: ids, folderId, ...this.getRequestQuery(this.currentWhereFolder) }
        }
        this[funcName](this.moveProjectFolderCb, params); 
      }
    },
    deleteProjectFolderCb(res) {
      const isFolder = this.folderIsFn(this.delete$.target[0]);
      if (res) {
        this.operatioSuccessfulFn();
      } else {
        const funcName = isFolder ? "del_folder$" : "del_project$";
        const ids = this.delete$.target.map(item => this.getItemId(item))
        const params = isFolder ? {folderIds: ids, folderId: ids[0] } : {projectIds: ids, projectId: ids[0] };
        this[funcName](this.deleteProjectFolderCb, params);
      }
    },
    renameProjectFolderCb (res) {
      const isFolder = this.folderIsFn(this.rename$.target[0]);
      if (res) {
        this.operatioSuccessfulFn();
      } else {
        if (!this.input || this.inputValidated) return;
        const funcName = isFolder ? "edit_folder$" : "edit_project$";
        const id = this.getItemId(this.rename$.target[0]);
        const params = isFolder
          ? { folderId: id, name: this.input }
          : { projectId: id, name: this.input };
        this[funcName](this.renameProjectFolderCb, params);
      }
    },
    addProjectFolderCb (res) {
      const isFolder = this.folderIsFn(this.add$.target)
      if (res) {
        if (!isFolder) {
          const { projectId } = res.data;
          this.$store.commit("SELECTEDMENUERIGHT", null);
          this.$store.commit("UPDATE_PROJECT_DATA", {
            projectId,
            name: this.input
          })
        }
        this.operatioSuccessfulFn();
      } else {
        if (!this.input && isFolder || this.inputValidated) return;
        const mp = { _id: "add_folder$", projectId: "add_project$" };
        isFolder || this.getArrayLastItem(this.headerDataD) // l$({ name: this.input, folderId: this.getArrayLastItem(this.headerDataD).query.folderId },  )
        const params = isFolder
          ? {
              path:
                (this.getArrayLastItem(this.headerDataD).query.path  === '/' ? '' : this.getArrayLastItem(this.headerDataD).query.path) +
                "/" +
                this.input,
                ...this.getRequestQuery(this.currentWhereFolderOfTable)
            }
          : { name: this.input, folderId: this.getArrayLastItem(this.headerDataD).query.folderId, ...this.getRequestQuery(this.currentWhereFolderOfTable) }
        
        this[mp[this.add$.target.type$]](this.addProjectFolderCb, params)
      }
    },
    
    closeDialogComponent() {
      Object.assign(this, {
        dialog: { ...this.dialog, isShow: false },
        currentSelectedFolderId: "",
        input: "",
        inputValidated: false,
        overMaxInputLen: false,
        switchState: false,
        switchDataValue: [],
        popDialog: { switch: false },
      })
    },
    operatioSuccessfulFn() {
      this.$emit("handleHeaderDataProxy", this.getArrayLastItem(this.headerDataD))
      this.closeDialogComponent()
    },
  },
  watch: {
    data (newVal) {
      Object.assign(this.dialog, newVal)
    },
    options (newVal) {
      console.log("options change:", newVal)
      const { data, key$: key, vm } = newVal;
      const obj = {};
      obj[key] = data;
      this.headerData = JSON.parse(JSON.stringify(this.headerDataD))
      this.folderList = JSON.parse(JSON.stringify(this.folderListD))
      Object.assign(this, obj)
      vm && Object.assign(this, vm)
      this.currentType = key;
      let target = data['target'];
      key === 'rename$' && (this.input = target[0]['name$']) 
      if(key === 'shared$'){
        if(target.length === 1){
          target = target[0];
          this.switchState = target.openStatus !== 'private';
          if(this.switchState){
            let groupIds = target.groups;
            if(groupIds.length === 0){
              this.switchDataValue = [''];
            } else {
              this.switchDataValue = groupIds;
            }
          } else {
            this.switchDataValue = [''];
          }
        } else {
          this.switchState = false;
          this.switchDataValue = [''];
        }
      }
    },
    currentWhereFolder (newVal) {
      this.isAllowedOpenSharedPop() && Object.assign(this.popDialog, { clickTarget: newVal })
    },
    switchDataValue (newVal, oldVal) {
      const index = this.switchDataValue.findIndex(o => o === '')
      if (newVal.length > 1) {
        oldVal.includes('') && this.switchDataValue.splice(index, 1)
        newVal.includes('') && (this.switchDataValue = [''])
      } else if (!newVal.length) {
        this.switchDataValue = ['']
      }
    },
    input (newVal) {
      if (newVal) {
        const matchChinese = newVal.match(/[\u4E00-\u9FA5]/g)
        const tLen = matchChinese ? matchChinese.length : 0
        const fn = (a, b, max, mode = 1) => {
          const allLen = (a - b) + (b * 2)
          if (mode === 1) return allLen > max
        }
        if (fn(newVal.length, tLen, 100)) {
          this.inputValidated = true
          this.overMaxInputLen = true
        } else if ( new RegExp(this.regularVer).test(newVal) ) {
          this.inputValidated = true
          this.overMaxInputLen = false
        } else {
          this.inputValidated = false
          this.overMaxInputLen = false
        } 
      }
    },
  },
  directives: {
    focus: {
      inserted (elm, { value }) {
        if (value || value === undefined) {
          elm.focus()
        }
      },
    },
  },
}
</script>

<style lang="scss">
.dialogOfManagecustomClass {
  background-color: transparent;
  .el-dialog__header {
    height: 60px;
    line-height: 60px;
    padding: 0px;
    background-color: #333333;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    .el-dialog__title {
      letter-spacing: 1px;
      color: #ffffff;
    }
  }
  .el-dialog__body {
    color: #c8c8c8;
    position: relative;
    height: 376px;
    box-sizing: border-box;
    
    padding: 0px;
    background-color: #444444;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
  }
}
.dialogOfManagecustomClassCrud {
  .el-dialog__body {
    height: auto;
    padding-bottom: 30px;
  }
}
.el-select {
  width: 280px;
  .el-input .el-input__inner {
    background-color: transparent;
  }
  .el-input .el-input__inner {
    border-width: 1px;
  }

}
.el-select-dropdown {
  border-radius: 8px;
  border-color: #a8a8ac;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected:hover {
  background-color: #444444!important;
}




.el-select-dropdown__item.is-disabled:hover {
  background-color: transparent;
}
.el-select-dropdown__item.is-disabled {
  cursor: default;
}
.el-select-dropdown__item {
  color:#fff;
}
.el-input .el-input__inner:focus {
  border-color: #1ac9f5;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #1ac9f5;
}
.el-tag.el-tag--info .el-tag__close {
  display: none;
}
.el-tag.el-tag--info {
    background-color: #333;
    border-color: #bbbbc1;
    color: #fff;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background-color: transparent;
  color: #1ac9f5;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
  background-color: transparent;
  color: #1ac9f5;
}
</style>
